import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { TemplatesCreateSchedulesCreateFormsModalsCreateControllerModule } from './controllers/TemplatesCreateSchedulesCreateFormsModalsCreateController';

export const TemplatesCreateSchedulesCreateFormsModalsCreateView = angular
  .module('acme.view.application.templates.create.schedules.create.forms.modals.create', [
    uiRouter,
    'ui.bootstrap',
    TemplatesCreateSchedulesCreateFormsModalsCreateControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.templates.create.schedules.create.forms.modals.create',
      url: '/templates/create/schedules/create/forms/modals/create',
      views: {
        main: {
          controller: 'TemplatesCreateSchedulesCreateFormsModalsCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/forms/modals/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: '       ',
        /** Secure With Permissions **/
        permissions: [],
      },
    });
  }).name;
